import styled from "styled-components";
import { HashLink as Link } from "react-router-hash-link";
import { MAIN_COLOR } from "../../../components/globalThemes";

export const StyledNavbarLink = styled(Link)`
    cursor: pointer;
    color: ${({ color }) => color ?? "white"};
    font-family: BlenderProBold, serif;
    font-size: 15px;
    letter-spacing: 1px;
    font-weight: 400;
    transition: 1s all;
    text-decoration: none;
    width: 150px;
    margin: 5px;
    text-align: center;
    text-transform: uppercase;
    text-decoration: none;
    padding: 2px;

    &:hover {
        color: ${({ color }) => color ?? MAIN_COLOR};
    }

    @media (max-width: 1250px) {
        width: 100px;
    }
`;
